<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">{{ $t("add") }} {{ $t("addons") }}</div>
    <section class="white-wrapper">
      <form class="row">
        <!-- CINEMA -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
                $tc("cinema", 2)
              }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  v-on:click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please select cinema.</span
            >
          </p>
        </div>
        <!-- ITEM NAME -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="add_on_object.add_on_item_name"
                name="addon_item_name"
                id="addon_item_name"
                v-validate="'required'"
              />
              <label>{{ $t("itemname") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('addon_item_name')">{{
              errors.first("addon_item_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-5 col-xl-4 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="add_on_object.alternate_add_on_name_language"
                name="alternate_addon_item_name"
                id="alternate_addon_item_name"
              />
              <label>{{ $t("alternatelangname") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <!-- ACTIVE -->
        <div class="col-lg-2 col-xl-2 align-self-center mb-1">
          <div class="d-flex align-items-center pb-3">
            <b-form-checkbox
              class="j-checkbox mb-0 ml-3"
              v-model="add_on_object.add_on_is_active"
              unchecked-value="N"
              value="Y"
            ></b-form-checkbox>

            <span>{{ $t("active") }}</span>
          </div>
        </div>

        <!-- ITEM DESC -->
        <div class="col-lg-3 col-xl-5 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="add_on_object.add_on_item_description"
                name="Item Description"
                id="Item Name"
              />
              <label>{{ $t("itemdes") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <!-- UOM -->
        <div class="col-lg-3 col-xl-3 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedUom.length > 0 ? 'shift-up' : ''">{{
                $tc("uom", 1)
              }}</label>
              <b-dropdown
                :text="selectedUom"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Unit"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUnit()"
                    v-on:keydown="onSearchUnit()"
                    v-on:search="onSearchUnit()"
                    v-model="searchUnit"
                  />
                </div>
                <b-dropdown-item
                  v-for="(uom, uomIndex) in UomList"
                  :key="uomIndex"
                  v-on:click="onSelectUom(uom)"
                  >{{ uom.uom_unit }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedUom.length == 0"
              >Please select unit of measurement.</span
            >
          </p>
        </div>
        <!-- MAX QTY -->
        <div class="col-lg-2 col-xl-2 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                style="text-align:right"
                placeholder="."
                type="numeric"
                v-model="add_on_object.add_on_max_quantity"
                name="max_qty"
                id="max_qty"
                v-validate="'required|decimal'"
              />
              <label>{{ $t("Max") }} {{ $t("quantity") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('max_qty')">{{
              errors.first("max_qty")
            }}</span>
          </p>
        </div>
        <!-- ITEM PRICE -->
        <div class="col-lg-2 col-xl-2 align-self-center mb-1">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                style="text-align:right"
                placeholder="."
                type="numeric"
                v-on:keyup="onChangeItemPrice($event)"
                v-model="add_on_object.add_on_item_price"
                name="addon_item_price"
                id="addon_item_price"
                v-validate="'required|decimal'"
              />
              <label>{{ $t("itemPrice") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('addon_item_price')">{{
              errors.first("addon_item_price")
            }}</span>
          </p>
        </div>
        <!-- TAX SWITCH -->
        <div class="col-lg-3 col-xl-4 align-self-center mb-1">
          <div
            class="d-flex align-items-center mb-1"
            :class="add_on_object.is_tax_applicable == 'Y' ? 'pb-3' : ''"
          >
            <b-form-checkbox
              class="j-checkbox ml-3 mb-0"
              v-model="add_on_object.is_tax_applicable"
              unchecked-value="N"
              value="Y"
            ></b-form-checkbox>

            <span>{{ $t("Tax Applicable") }}</span>
          </div>
        </div>
        <!-- CHARGE SETTING -->
        <div
          v-if="add_on_object.is_tax_applicable == 'Y'"
          class="col-lg-6 col-xl-4 align-self-center mb-1"
        >
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedChargeSettings.length > 0 ? 'shift-up' : ''"
                >{{ $tc("chargesettingname", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedChargeSettings"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Setting"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchSettings($event.target.value)"
                    v-on:keydown="onSearchSettings($event.target.value)"
                    v-model="searchChargeSettings"
                  />
                </div>
                <b-dropdown-item
                  v-for="(chargeSetting, chargeSettingIndex) in chargeSettings"
                  :key="chargeSettingIndex"
                  v-on:click="onSelectSettings(chargeSetting)"
                  >{{ chargeSetting.pas_charge_setting_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedChargeSettings.length == 0"
              >Please select charge settings.</span
            >
          </p>
        </div>

        <table
          class="col-xl-8"
          v-if="add_on_object.is_tax_applicable == 'Y'"
          style=""
        >
          <tr
            v-for="(cinemaCharge, cinemaChargesListIndex) in extraCharges"
            :key="cinemaChargesListIndex"
            class="new-bor"
          >
            <td>
              <div class="d-flex" style="gap:5px">
                <span class="font-weight-bold ">{{ $tc("charge", 2) }}:</span>
                {{ cinemaCharge.ct_name }}
              </div>
            </td>
            <td class="text-right">
              {{ cinemaCharge.pas_charge_value.toFixed(2)
              }}{{ cinemaCharge.pas_is_percentage == "Y" ? "%" : "" }}
            </td>
            <td class="text-right">
              {{
                cinemaCharge.cinemacharges &&
                cinemaCharge.pas_charge_value != NaN
                  ? cinemaCharge.cinemacharges.toFixed(2)
                  : 0
              }}
            </td>
          </tr>

          <tr class="new-bor" v-if="add_on_object.is_tax_applicable == 'Y'">
            <td>
              <div class="d-flex" style="gap:5px">
                <span class="font-weight-bold">Net Amount:</span>
                <span>{{
                  add_on_object.net_amount && add_on_object.net_amount != NaN
                    ? add_on_object.net_amount.toFixed(2)
                    : 0
                }}</span>
              </div>
            </td>

            <td colspan="2">
              <div class="d-flex" style="gap:5px">
                <span class="font-weight-bold">Gross Total:</span>
                <span>{{
                  add_on_object.total_amount &&
                  add_on_object.total_amount != NaN
                    ? add_on_object.total_amount.toFixed(2)
                    : 0
                }}</span>
              </div>
            </td>
          </tr>
        </table>

        <!-- CHARGES -->
        <div
          v-if="add_on_object.is_tax_applicable == 'Y' && false"
          class="col-md-12"
        >
          <div>
            <div class="font-weight-bold mb-2">{{ $tc("charge", 2) }}</div>
          </div>

          <div
            class="col-12"
            v-for="(cinemaCharge, cinemaChargesListIndex) in extraCharges"
            :key="cinemaChargesListIndex"
          >
            <div class="row">
              <div class="col-md-5 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <label>{{ cinemaCharge.ct_name }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-5">
                    <div
                      class="d-flex justify-content-center align-items-center p-3"
                    >
                      <label
                        >{{ cinemaCharge.pas_charge_value
                        }}{{
                          cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                        }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div
                      class="d-flex justify-content-center align-items-center p-3"
                    >
                      <label>{{
                        cinemaCharge.cinemacharges &&
                        cinemaCharge.pas_charge_value != NaN
                          ? cinemaCharge.cinemacharges.toFixed(4)
                          : 0
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="text-right"></div>
          </div>
          <div class="col-md-12">
            <div class="text-right"></div>
          </div>
        </div>
        <!-- SUNDRY -->
        <div
          :class="
            add_on_object.is_tax_applicable == 'Y'
              ? 'col-lg-4 col-xl-4 align-self-center mb-1'
              : 'col-lg-4 col-xl-4 align-self-center mb-1'
          "
        >
          <div
            class="d-flex align-items-center mb-1"
            :class="
              add_on_object.is_tax_applicable == 'N'
                ? ' justify-content-start'
                : 'justify-content-center'
            "
          >
            <b-form-checkbox
              class="j-checkbox mb-0 ml-3"
              v-model="add_on_object.is_sundry_item"
              unchecked-value="N"
              value="Y"
            ></b-form-checkbox>

            <span>{{ $t("isSundry") }}</span>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onResetForm()"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="add-ons">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import ExhibitorService from "@/services/ExhibitorService";
export default {
  data() {
    return {
      UomListCopy: [],
      searchUnit: "",
      btenable: false,
      isRoleID: true,
      submitted: false,

      Cinemas: [],
      CinemasCopy: [],
      selectedCinema: "",
      searchCinema: "",

      chargeSettings: [],
      chargeSettingsCopy: [],
      searchChargeSettings: "",
      selectedChargeSettings: "",

      UomList: [],
      selectedUom: "",

      add_on_object: {
        cinema_id: null,
        add_on_item_name: "",
        alternate_add_on_name_language: "",
        add_on_item_description: "",
        add_on_item_price: "",
        add_on_uom_id: null,
        add_on_max_quantity: null,
        is_tax_applicable: "N",
        is_sundry_item: "Y",
        add_on_is_active: "Y",
        pas_id: null,
        net_amount: 0,
        total_amount: 0
      },

      extraCharges: []
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    this.getUomList();
  },
  methods: {
    onSearchUnit: function() {
      if (this.searchUnit && this.searchUnit.length > 0) {
        this.UomList = this.UomListCopy.filter(x => {
          if (
            x.uom_unit.toLowerCase().includes(this.searchUnit.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.UomList = this.UomListCopy;
      }
    },
    onSearchCinema: function(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchSettings: function(value) {
      if (this.searchChargeSettings && this.searchChargeSettings.length > 0) {
        this.chargeSettings = this.chargeSettingsCopy.filter(x => {
          if (
            x.cine_name
              .toLowerCase()
              .includes(this.searchChargeSettings.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.chargeSettings = this.chargeSettingsCopy;
      }
    },
    getCinemasList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUomList: function() {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
            this.UomListCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectUom(value) {
      this.selectedUom = value.uom_unit;
      this.add_on_object.add_on_uom_id = value.uom_id;
      this.searchUnit = "";
      this.onSearchUnit();
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.add_on_object.cinema_id = params.cine_id;
      this.getPasSettingName(params.cine_id);
    },
    getPasSettingName: function(id, index) {
      this.chargeSettings = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.chargeSettings = data.Records;
            this.chargeSettingsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectSettings: function(params) {
      this.selectedChargeSettings = params.pas_charge_setting_name;
      this.add_on_object.pas_id = params.pas_id;
      this.getCinemaCharges(this.add_on_object.cinema_id);
    },
    getCinemaCharges: function(id) {
      this.extraCharges = [];
      let payload = {
        pas_charge_setting_name: this.selectedChargeSettings,
        id: id
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.extraCharges = data.Records;
            let promises = this.extraCharges.map(x => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation();
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onChangeItemPrice: function(event) {
      this.cinemaChargesCalculation();
    },
    cinemaChargesCalculation: function() {
      this.add_on_object.net_amount = parseFloat(
        this.add_on_object.add_on_item_price
      );
      this.add_on_object.total_amount = parseFloat(
        this.add_on_object.add_on_item_price
      );

      this.extraCharges.map(x => {
        if (x.pas_is_percentage === "Y") {
          x.cinemacharges =
            ((parseFloat(this.add_on_object.add_on_item_price) /
              this.calculatePercentageCharge()) *
              parseFloat(x.pas_charge_value)) /
            100;
        }
        this.calculateNetAmount(x, "Minus");
        if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          x.cinemacharges =
            parseFloat(x.pas_charge_value) * this.calculateTaxableCharge();
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          x.cinemacharges = parseFloat(x.pas_charge_value);
        }
        return x;
      });
      this.$forceUpdate();
    },
    calculateTaxableCharge: function() {
      let finalvalue = 1;
      this.extraCharges.map(x => {
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    calculateNetAmount: function(x, equation, index) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y") {
          this.add_on_object.total_amount += parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.add_on_object.total_amount += parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y") {
          this.add_on_object.net_amount -= parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.add_on_object.net_amount -= parseFloat(x.pas_charge_value);
        }
      }
    },
    calculatePercentageCharge: function() {
      let finalvalue = 1;
      this.extraCharges.map(x => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    onResetForm: function() {
      this.add_on_object = {
        cinema_id: null,
        add_on_item_name: "",
        alternate_add_on_name_language: "",
        add_on_item_description: "",
        add_on_item_price: "",
        add_on_uom_id: null,
        add_on_max_quantity: null,
        is_tax_applicable: "N",
        add_on_is_active: "Y",
        pas_id: null,
        net_amount: 0,
        total_amount: 0
      };
      this.selectedUom = "";
      this.selectedChargeSettings = "";
      this.selectedCinema = "";
      this.extraCharges = [];
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (
          this.add_on_object.cinema_id == null ||
          this.add_on_object.add_on_uom_id == null ||
          (this.add_on_object.is_tax_applicable == "Y" &&
            this.add_on_object.pas_id == null)
        ) {
          return;
        }
        if (valid) {
          let loader = this.$loading.show();
          let payload = {
            ...this.add_on_object,
            extraCharges: this.extraCharges
          };
          MasterService.CreateAddon(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              loader.hide();
              if (data && data.status) {
                this.onResetForm();
                this.$router.push({
                  path: "/master/add-ons"
                });
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            }); //message
        }
      });
    }
  }
};
</script>

<style>
.new-bor td {
  border: 1px solid black;
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AddonsComponents/addAddons.vue